/**
 * @author NikolaV
 */
import { DrawInteractionTool } from '@openlayers/tools/tool-base';

import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import { Point as OlPoint } from 'ol/geom';
import * as olStyle from 'ol/style';


export class SelectionTool extends DrawInteractionTool {
    targetSource: VectorSource = null; // where to look for features
    features: Feature[] = [];

    finishedStyle = new olStyle.Style({
        fill: new olStyle.Fill({
            color: 'rgba(120, 200, 45, 0.2)',
        }),
        stroke: new olStyle.Stroke({
            color: '#75B42D',
            width: 2,
        }),
        image: new olStyle.Circle({
            radius: 7,
            fill: new olStyle.Fill({
                color: '#75B42D',
            }),
        }),
    });

    constructor(
        mapInstance,
        targetSource: VectorSource,
        public onSelect: (ids: Feature[]) => any
    ) {
        super(mapInstance);
        this.targetSource = targetSource;
    }

    onDrawStart = e => { // OlDrawEvent
        this.clear();
    }

    onDrawEnd = e => { // OlDrawEvent
        super.onDrawEnd(e);
        const areaFeature: Feature = e.feature;
        const allFeatures: Feature[] = this.targetSource.getFeatures();
        const hitFeatures: Feature[] = [];

        for (const f of allFeatures) {
            const point: OlPoint = f.getGeometry() as OlPoint;
            const coord = point.getCoordinates();

            if (areaFeature.getGeometry().intersectsCoordinate(coord)) {
                hitFeatures.push(f);
            }
        }

        setTimeout(() => { // without timeout, feature geometry is not created at this point
            this.onSelect(hitFeatures);
        }, 1);
    }

    deactivate = () => {
        super.deactivate();
        this.clear();
    }

    clear = () => {
        super.clear();
        this.features.forEach(f => this.targetSource.removeFeature(f));
        this.features = [];
    }
}

